module.exports = __webpack_public_path__ + "static/img/Cardfooter04.3958036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cardfooter04.png
// module id = 12nZ
// module chunks = 1